import React from "react";
import {ContentsLoading} from "./Contents";
import {
  borderStyles,
  containerSpaceStyles,
} from "@components/Booking/LocationSelection/LocationRow/styles";

const styles = `${borderStyles} ${containerSpaceStyles}`;
const RowLoading = () => {
  return (
    <div className={styles}>
      <ContentsLoading />
    </div>
  );
};

export default React.memo(RowLoading);
